import {
    ApplicationInsights,
    DistributedTracingModes,
} from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { createBrowserHistory } from "history";
const browserHistory = createBrowserHistory({});
export const reactPlugin = new ReactPlugin();

export const appInsights = new ApplicationInsights({
    config: {
        connectionString: "",
        extensions: [reactPlugin],
        extensionConfig: {
            [reactPlugin.identifier]: { history: browserHistory },
        },
        enableAutoRouteTracking: true,
        enableCorsCorrelation: true,
        maxBatchInterval: 15000,
        disableFetchTracking: false,
        disableExceptionTracking: false,
        samplingPercentage: 100,
        loggingLevelConsole: 2,
        loggingLevelTelemetry: 2,
        autoTrackPageVisitTime: true,
        distributedTracingMode: DistributedTracingModes.AI_AND_W3C,
    },
});
